import React from 'react';
import ConnectionTemplateConnectionGroupVM from './connection-template-connection-groups.viewmodel';
import { ADD_CONNECTION_GROUP_BTN_TEXT, CONNECTION_GROUPS_TEXT } from '../../../../_events/_manage-event/shared/connection-groups-list/connection-groups.texts';
import { editText, REMOVE_TEXT } from '../../../../../constants/common-labels.constants';
import { ConnectionTemplateConnectionGroupListItem } from './connection-template-connection-group-list-item';
import { OERadioSingleOption } from '../../../../global/oe-radio-options/oe-radio-single-option';
import DefaultButton from '../../../../global/default-button/default-button';
import { observer } from 'mobx-react';

export interface IConnectionTemplateConnectionGroupPresentationProps {
    vm: ConnectionTemplateConnectionGroupVM;
}

const editButtonText = editText();

const ConnectionTemplateConnectionGroupPresentation = observer(({
    vm,
}: IConnectionTemplateConnectionGroupPresentationProps) => {

    return (
        <div className='connection-list connection-list__meeting-connections'>
            <div className='connection-list__label-wrapper'>
                <div className='connection-list__label connection-list__label--wide'>
                    { vm.intl.formatMessage(CONNECTION_GROUPS_TEXT) }
                </div>
            </div>
            {vm.groupList.map(group => {
                const connectionGroupsPassportPreviewViewModel = vm.getPassportPreviewVM(group);
                return (
                    <div
                        key={group.meetingConnectionId}
                        className='connection-list__connection-wrapper connection-group-item connection-list__connection-wrapper--pl'
                    >
                        <ConnectionTemplateConnectionGroupListItem
                            group={group}
                            onEditGroup={vm.openEditGroupPopup}
                            orderedConnections={vm.getOrderedConnections}
                            editButtonText={editButtonText}
                            isSelected={vm.isGroupPopupOpen(group.meetingConnectionId)}
                            connectionGroupsPassportPreviewViewModel={connectionGroupsPassportPreviewViewModel}
                        />
                        <div className='connection-list__radio-default'>
                            <OERadioSingleOption
                                checked={group.isDefaultConnection}
                                value={group.meetingConnectionId}
                                onToggle={() => vm.formVM.setDefaultConnection(group)}
                                allowUncheck={true}
                            />
                        </div>
                        <div
                            className='m-left-auto'
                            onClick={() => vm.onDeleteConnectionGroup(group.meetingConnectionId)}
                            data-test-id='remove-group'
                        >
                            <label
                                className='organization__remove-label m-right-10px'
                            >
                                { vm.intl.formatMessage(REMOVE_TEXT) }
                            </label>
                        </div>
                    </div>
                );
            })}
            <DefaultButton
                className='connection-list__add-group-button add-line-to-table-btn'
                modifier='slim'
                isActive={vm.isNewGroupPopupOpened}
                text={vm.intl.formatMessage(ADD_CONNECTION_GROUP_BTN_TEXT)}
                onClick={vm.openAddConnectionGroupPopup}
            />
        </div>
    );
});

export default ConnectionTemplateConnectionGroupPresentation;